import { fetcher } from "helpers/fetcher";

import {
  TUpdateEODReportDetailsReq,
  TUpdateEODReportDetailsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEODReportDetails = async (
  payload: TUpdateEODReportDetailsReq
) => {
  return await fetcher<
    TUpdateEODReportDetailsRes,
    TUpdateEODReportDetailsReq["data"]
  >(ENDPOINT.MANAGEMENT.UPDATE_EOD_REPORT_DETAILS, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.UPDATE_EOD_REPORT_DETAILS.version,
      [API_HEADER.BU_ID]: payload.idBu,
    },
    urlData: {
      date: payload.data.date,
      idTicket: payload.data.idTicket,
    },
  });
};

export const mutationUpdateEODReportDetails = async (
  payload: TUpdateEODReportDetailsReq
) => {
  return (await updateEODReportDetails(payload)).data.message;
};

mutationUpdateEODReportDetails._key = (payload: TUpdateEODReportDetailsReq) => [
  ENDPOINT.MANAGEMENT.UPDATE_EOD_REPORT_DETAILS.url,
  payload,
];
